import MiddlePanel from 'Components/MiddlePanel/MiddlePanel';
import Panel from 'Components/Panel/Panel';
import { useEffect, useState } from 'react';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import InputField from 'Components/Input/InputField';

const TotalPiecesPanel = ({
    productionDaysIdSelecteds,
    setTotalPiecesPanelShow,
    totalPiecesPanelShow,
    setReactivateQuantityProducedPiecesPanel
}) => {
    const [totalPieces, setTotalPieces] = useState(null)

    useEffect(() => {
        if (productionDaysIdSelecteds.length == 1) {
            validateToSetTotalPieces(productionDaysIdSelecteds[0])
        }
    }, [totalPiecesPanelShow]);

    async function validateToSetTotalPieces(productionDaysIdSelecteds) {
        const parameters = {
            productionDayId: productionDaysIdSelecteds
        }
        const totalPieces = await ExecuteAxios.api('get', `/production-hour/get-total-pieces-hour/`, { params: parameters })
        setTotalPieces(totalPieces)
    }

    async function putTotalPieces() {
        const response = await ExecuteAxios.api('put', `/production-hour/total-pieces-hour/`, {
            productionDayId: productionDaysIdSelecteds[0],
            totalPieceHour: totalPieces
        });

        if (response) {
            setReactivateQuantityProducedPiecesPanel(true)
            setTotalPiecesPanelShow(false)
        }

        return response;
    }

    return (
        <MiddlePanel isVisible={totalPiecesPanelShow}>
            <Panel style={{
                width: '450px',
                height: '200px',
                padding: '5px',
                borderRadius: '10px',
                backgroundColor: '#f5f5f5',
                border: '1px solid #ccc',
                boxShadow: '0px 0px 10px rgba(0, 0, 0, 30%)'
            }}>
                <Panel titlePage={'Informe o total de peças'}
                    canViewCRUD={true}
                    putFunction={putTotalPieces}
                    enableEdit={true}
                    canEdit={true}
                    cancelFunction={() => setTotalPiecesPanelShow(false)}
                    updating={true}
                >
                    <div id='attribute-control'>
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <label>Total de peças:</label>
                        </div>
                        <InputField
                            setAttribute={setTotalPieces}
                            value={totalPieces}
                            readOnly={false}
                            disabled={false}
                            style={{ width: '150px' }}
                        />
                    </div>
                </Panel>
            </Panel>
        </MiddlePanel >
    );
}

export default TotalPiecesPanel;
